import React from 'react';

interface ScrollObserver {
  observer: IntersectionObserver;
  isVisible: (el) => boolean;
}

export const ScrollObserverContext = React.createContext<ScrollObserver>(null);
